/**
 * @file components/common/ConfigProvider
 * @author zhangzhe(zhangzhe@baidu.com)
 */

import React from 'react';
import type {EmptyProps} from 'acud/lib/empty';

import LocaleContext from '../../locale/context';
import type {Locale} from 'src/components/locale';
import {ACUD_PRO_PREFIX} from '../../_common/constants';

export interface ConfigConsumerProps {
    prefixCls?: string;
    locale?: Locale;
    table?: {
        queryParamKeys?: boolean | string[];
        ajaxActionErrorToast?: boolean;
        fetchActionErrorToast?: boolean;
    },
    form?: {
        defaultValueForceUpdate?: boolean;
    },
    emptyStatus?: {
        config?: Record<string, EmptyProps>;
    }
}

export interface ConfigProviderProps extends ConfigConsumerProps {
    children?: React.ReactNode;
}

export const ConfigContext = React.createContext<ConfigConsumerProps>({});

export const ConfigConsumer = ConfigContext.Consumer;

const ProConfigProvider: React.FunctionComponent<ConfigProviderProps> = props => {

    const {children, prefixCls = ACUD_PRO_PREFIX, locale, table, form, emptyStatus} = props;

    let childNode = children;

    const config: ConfigConsumerProps = {
        prefixCls,
        table,
        form,
        emptyStatus
    };

    if (locale) {
        childNode = (
            <LocaleContext.Provider value={{...locale, exist: true}}>
                {children}
            </LocaleContext.Provider>
        );
    }

    return (
        <ConfigContext.Provider value={config}>
            {childNode}
        </ConfigContext.Provider>
    );
};

export default ProConfigProvider;